import { render, staticRenderFns } from "./PasswordSettingsSection.vue?vue&type=template&id=4115aedc&scoped=true&"
import script from "./PasswordSettingsSection.vue?vue&type=script&lang=js&"
export * from "./PasswordSettingsSection.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSettingsSection.vue?vue&type=style&index=0&id=4115aedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115aedc",
  null
  
)

export default component.exports